import { ShieldCheck, Zap, Hand } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { useI18n } from "@/lib/i18n";
export type PermissionMode = "ASK" | "EDIT" | "FULL";
export function PermissionSelector({
  value,
  onChange,
}: {
  value: PermissionMode;
  onChange(value: PermissionMode): void;
}) {
  const fr = useI18n().language === "fr";
  const options = [
    {
      id: "ASK",
      icon: Hand,
      title: fr ? "Demander" : "Ask",
      description: fr
        ? "Modifications simples explicites, aperçu pour les autres actions."
        : "Explicit simple edits; preview other actions.",
    },
    {
      id: "EDIT",
      icon: ShieldCheck,
      title: fr ? "Modifications" : "Allow edits",
      description: fr
        ? "Modifications et opérations groupées. Confirmation avant suppression."
        : "Edits and bulk changes; confirm destructive actions.",
    },
    {
      id: "FULL",
      icon: Zap,
      title: fr ? "Accès complet" : "Full access",
      description: fr
        ? "Appliquer les actions et les documents automatiquement, y compris les suppressions."
        : "Apply actions and document changes automatically, including deletions.",
    },
  ];
  const selected = options.find((o) => o.id === value)!;
  return (
    <Select value={value} onValueChange={(v) => onChange(v as PermissionMode)}>
      <SelectTrigger
        aria-label={fr ? "Permissions de l’assistant" : "Assistant permissions"}
        className="h-8 w-auto min-w-0 gap-2 rounded-lg border-white/10 bg-white/[0.03] px-2.5 text-xs"
      >
        <selected.icon className="h-3.5 w-3.5 text-primary" />
        <span>{selected.title}</span>
      </SelectTrigger>
      <SelectContent className="max-w-[min(25rem,90vw)]">
        {options.map((o) => (
          <SelectItem key={o.id} value={o.id}>
            <div className="flex items-start gap-2 py-1">
              <o.icon className="h-4 w-4 mt-0.5 shrink-0 text-primary" />
              <div>
                <p className="font-medium text-sm">{o.title}</p>
                <p className="text-xs text-foreground-muted whitespace-normal max-w-72">
                  {o.description}
                </p>
              </div>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
